import { render, staticRenderFns } from "./AccountPropsView.vue?vue&type=template&id=9ab21cc8&"
import script from "./AccountPropsView.vue?vue&type=script&lang=js&"
export * from "./AccountPropsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports